var React = require('react');

function Demo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.42395 8.0874H21.424C24.2529 8.0874 26.966 9.21121 28.9664 11.2116C30.9668 13.212 32.0906 15.9251 32.0906 18.7541V56.0874C32.0906 53.9657 31.2478 51.9308 29.7475 50.4305C28.2472 48.9303 26.2123 48.0874 24.0906 48.0874H5.42395V8.0874Z","stroke":"#F4F4F4","strokeWidth":"5.33333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M58.7572 8.0874H42.7572C39.9283 8.0874 37.2152 9.21121 35.2148 11.2116C33.2144 13.212 32.0906 15.9251 32.0906 18.7541V56.0874C32.0906 53.9657 32.9334 51.9308 34.4337 50.4305C35.934 48.9303 37.9688 48.0874 40.0906 48.0874H58.7572V8.0874Z","stroke":"#F4F4F4","strokeWidth":"5.33333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Demo.defaultProps = {"width":"65","height":"65","viewBox":"0 0 65 65","fill":"none"};

module.exports = Demo;

Demo.default = Demo;
